<template>
    <div v-if="showModal" id="parcel_order_modal" class="ui center aligned grid">
        <div class="column">
            <div id="header" class="ui top fixed menu">
                <h3>{{ order.partnerName }} 발주 내역 ({{ new Date(order.createdAt).format("yy-MM-dd (KS) HH:mm") }}) - {{ order._id }}</h3>
            </div>
            <div id="body" class="scrolling content">
                <table class="ui striped celled compact table">
                    <thead>
                        <tr>
                            <th class="collapsing">#</th>
                            <th class="collapsing">판매처</th>
                            <th class="collapsing">타입</th>
                            <th class="collapsing">택배사</th>
                            <th class="collapsing">운송장번호</th>
                            <th class="collapsing">주문날짜</th>
                            <th class="collapsing">상품명</th>
                            <th class="collapsing">수량</th>
                            <th class="collapsing">주문자</th>
                            <th class="collapsing">주문자연락처</th>
                            <th class="collapsing">수취인</th>
                            <th class="collapsing">수취인연락처</th>
                            <th class="collapsing">수취인주소</th>
                            <th class="collapsing">고객요청사항</th>
                            <th class="collapsing">메모</th>
                        </tr>
                    </thead>
                    <tbody v-if="items.length > 0">
                        <tr v-for="(item, index) in items" :key="item._id">
                            <td class="collapsing"> {{ index + 1 }} </td>
                            <td class="collapsing"> {{ item.seller }} </td>
                            <td class="collapsing"> {{ constantNames[item.type] }} </td>
                            <td class="collapsing">
                                <select class="ui simple dropdown" v-model="item.company" :disabled="!isHeader || order.confirmedAt">
                                    <option :value="''">없음</option>
                                    <option :value="'롯데'">롯데</option>
                                    <option :value="'대신'">대신</option>
                                    <option :value="'로젠'">로젠</option>
                                    <option :value="'일양'">일양</option>
                                    <option :value="'한진'">한진</option>
                                    <option :value="'대한'">대한</option>
                                </select>
                                <!-- <div :class="isHeader && !order.confirmedAt ? 'ui fluid input' : 'ui disabled fluid input'">
                                    <input type="text" v-model="item.company">
                                </div> -->
                            </td>
                            <td class="collapsing">
                                <div :class="isHeader && !order.confirmedAt ? 'ui fluid input' : 'ui disabled fluid input'">
                                    <input type="text" v-model="item.number">
                                </div>
                            </td>
                            <td class="collapsing"> {{ new Date(item.orderedAt).format("yy-MM-dd (KS)") }} </td>
                            <td class="collapsing"> {{ item.product }} </td>
                            <td class="collapsing"> {{ item.count }} </td>
                            <td class="collapsing"> {{ item.orderer }} </td>
                            <td class="collapsing"> {{ item.ordererTel }} </td>
                            <td class="collapsing"> {{ item.receiver }} </td>
                            <td class="collapsing"> {{ item.receiverTel }} </td>
                            <td class="collapsing"> {{ item.address }} </td>
                            <td class="collapsing"> {{ item.clientMemo }} </td>
                            <td class="collapsing"> {{ item.partnerMemo }} </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="footer" class="ui bottom fixed text menu">
                <div class="right menu">
                    <div class="item" v-if="!order.confirmedAt && isHeader && isUploadReady">
                        <input type="file" @change="onOpenExcelFile">
                    </div>
                    <div class="item" v-if="!order.confirmedAt && isHeader">
                        <div class="ui primary button" @click="confirm">확정</div>
                    </div>
                    <div class="item">
                        <div class="ui teal button"  @click="download">다운로드</div>
                    </div>
                    <div class="item">
                        <div class="ui button"  @click="close">닫기</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data: function() {
        return {
            showModal: 0, order: 0, items: 0, isUploadReady: 0, onChange: 0, 
        }
    },
    created: function() {
        this.showModal = false;
        this.order = this.items = this.onChange = 0;
        this.$event.set("parcelOrder_detail", this.open);
    },
    mounted: function() {
        window.addEventListener('keyup', (e) => { if (this.showModal && e.keyCode === 27) this.close(); });
    },
    destroyed: function() {
        this.$event.clear("parcelOrder_detail");
    },
    methods: {
        open(order, onChange) {
            if (order) {
                this.$event.call("openLoading");
                this.$api.getOneParcelOrder(order._id, (resData) => {
                    this.$event.call("closeLoading");
                    if (resData.error) {
                        alert(resData.error.message);
                    } else {
                        this.showModal = true;
                        this.order = order;
                        this.items = resData.items;
                        this.onChange = onChange;
                        this.reloadFile();
                    }
                });
            }
        },
        close() {
            this.showModal = false;
        },
        reloadFile() {
            this.isUploadReady = false;
            this.$nextTick(() => this.isUploadReady = true);
        },
        download() {
            const dateText = new Date(this.order.createdAt).format("yyyyMMdd");
            this.$excel.downloadParcel(this, this.items, dateText + "_" + this.order.partnerName + "_택배발주내역");
        },
        confirm() {
            this.$event.call("openLoading");
            this.$api.confirmParcelOrder(this.user._id, this.order._id, this.items, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    this.close();
                    if (this.onChange) this.onChange();
                }
            });
        },
        onOpenExcelFile() {
            this.fileName = event.target.files[0].name;
            this.$event.call("openLoading");
            this.$excel.readFile(event.target.files[0], (excelData) => {
                for (var i=0; i<excelData.length; i++) {
                    if (i < this.items.length) {
                        if (!excelData[i]["운송장번호"]) { alert("운송장번호를 찾을 수 없습니다!"); break; }
                        if (!excelData[i]["주문자"]) { alert("주문자를 찾을 수 없습니다!"); break; }
                        if (this.items[i].orderer == excelData[i]["주문자"]) {
                            this.items[i].number = excelData[i]["운송장번호"];
                            this.items[i].company = excelData[i]["택배사"];
                        }
                    }
                }
                this.reloadFile();
                this.$event.call("closeLoading");
            });
        },
    },
    computed: {
        isHeader: function() { return this.$store.getters.isHeader; },
        user: function() { return this.$store.getters.user; },
        partners: function() { return this.$store.getters.partners; },
        centers: function() { return this.$store.getters.centers; },
        workers: function() { return this.$store.getters.workers; },
        constant: function() {return this.$store.getters.constant; },
        constantNames: function() {return this.$store.getters.constantNames; },
    },
}
</script>

<style>

#parcel_order_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: #fff;
}

#parcel_order_modal .column {
    width: 100%;
    min-Width: 100%;
    max-width: 100%;
}

#parcel_order_modal #header {
    padding: 20px 30px;
}

#parcel_order_modal #body {
    margin: 80px 0;
    width: 100%;
    font-size: 12px;
    overflow: auto;
}

#parcel_order_modal #body .ui.input {
    width: 120px;
}

#parcel_order_modal #header {
    padding: 20px 30px;
}

#parcel_order_modal #footer {
    padding: 20px 30px;
    background-color: #eee;
}

</style>


// WEBPACK FOOTER //
// src/components/ParcelOrderModal_Detail.vue